import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'auth-role-list',
  templateUrl: './role-list.component.html',
  styleUrls: ['./role-list.component.css'],
})
export class RoleListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
